jQuery( document ).ready(function() {

    // Calculate slider indicators width based on how many there are
    jQuery(".picture-grid-popup").each(function() {
        var popupId = jQuery(this).data('popup-group');
        var totalIndicators = jQuery(this).children('.picture-grid-item-container').first().find('.bar .indicator').length;
        var indicatorWidth = 100 / totalIndicators;
        jQuery('.popup[data-popup-group="'+popupId+'"] .popup-navigation .bar .indicator').css({ 'width': ( ( indicatorWidth <= 6 ) ? '8px' : indicatorWidth+'%' ) });
    });

    // Show active indicator
    jQuery('.modal-open').click(function() {
        var popupId = jQuery(this).attr('href').replace("#", "");
        jQuery('.indicator').removeClass('active');
        jQuery('.indicator[data-popup='+popupId+']').addClass('active');
    });

    // Navigation
    jQuery('.picture-grid-popup .popup-navigation .prev, .picture-grid-popup .popup-navigation .next').click(function() {
        var activePopupGroup = jQuery(this).parents('.popup').data('popup-group');
        var activePopupIndicator = jQuery(this).parents('.popup').find('.indicator.active').data('popup');
        var activePopupIndicatorNo = activePopupIndicator.replace(activePopupGroup+'_', "") * 1;
        var direction = ( ( jQuery(this).hasClass('prev') ) ? -1 : 1 );
        // Next item
        var nextIndicator = jQuery('.indicator[data-popup='+activePopupGroup+'_'+(activePopupIndicatorNo + direction)+']');
        if(!nextIndicator.length) {
            // Last item
            if(direction > 0) {
                nextIndicator = jQuery(this).parents('.popup').find('.popup-navigation .bar .indicator').first();
            }
            // First item
            else {
                nextIndicator = jQuery(this).parents('.popup').find('.popup-navigation .bar .indicator').last();
            }
        }
        nextIndicator.click();
    });

});